/** Enum with url non criteria url params */
export enum HisSearchNonCriteriaUrlParam {
    CONFIG_FILE = 'configFile',
    PAGE_TITLE = 'pageTitle',
    TABLE_TITLE = 'tableTitle',
    IS_NO_SEARCH_ACTIVE = 'isNotActiveSearch',
    SHOW_CHANGE_SEARCH_BUTTON = 'showChangeSearchButton',
    SHOW_SEARCH_BUTTON = 'showSearchButton',
    SHOW_BACK_BUTTON = 'showBackButton',
    PAGE = 'page',

    // blacklisted keys are ignored, see #192323, #212551, #249099
    NO_DB_ACTION = 'noDBAction',
    INIT = 'init',
    CHOC = 'chco',
    EXTENDED = 'extended',
    MODE = 'mode',
    RECORD_REQUEST = 'recordRequest',
    NAVIGATION_POSITION = 'navigationPosition'

}
